<template>
	<div id="RecetaNutricionales">

		<b-form inline>

			<b-form-select v-model="form.id_elemento_fk" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0">
				<b-form-select-option :value="null">Selecciona un elemento</b-form-select-option>
				<b-form-select-option v-for="i in elementonutricionalDisponible" :key="i.id_pk" :value="i.id_pk">
					{{i.nombre}}
				</b-form-select-option>
			</b-form-select>

			<label class="sr-only" for="form-cantidad">{{selectedElementUM}}</label>

			<b-input-group :append="selectedElementUM" class="mb-2 mr-sm-2 mb-sm-0">
				<b-form-input v-model="form.cantidad" id="form-cantidad" style="width: 135px"></b-form-input>
			</b-input-group>

			<!-- <b-form-select v-model="form.id_unidadmedicion_fk" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0">
				<b-form-select-option :value="null">Selecciona la unidad</b-form-select-option>
				<b-form-select-option v-for="i in unidadmedicion" :key="i.id_pk" :value="i.id_pk">{{i.nombre}}</b-form-select-option>
			</b-form-select> -->
			
			<b-button variant="primary" @click="addItem()" :disabled="!(!!form.id_elemento_fk && !!form.id_unidadmedicion_fk && !!form.cantidad)">
				<i class="fa fa-plus"></i>
			</b-button>
			
		</b-form>

		<b-table hover :fields="fields" :items="items" no-guttes class="mt-3" v-if="items.length">
			<template #cell(_)="data">
                <b-button size="sm" variant="danger" @click="removeItem(data.item)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
		</b-table>
		<b-jumbotron class="mt-3 mb-0" header="Nutricionales" lead="Agrega nutricionales con la herramienta superior" v-else />
	</div>
</template>

<script>
import _ from "lodash";
let formArchetype = {
	cantidad: 1,
	observaciones: null,
	id_unidadmedicion_fk: 17,			// POR BDD SE USARÁ MILIGRAMO, PERO EN LA PRÁCTICA SE ENVIARÁ LA UNIDAD DE CAPTURA 
										// DE ELEMENTONUTRICIONAL SEGÚN unidaddemediciontextual
	id_elemento_fk: null,
	// id_encabezado_fk: null,          // ADMINISTRADO DESDE API
	// id_ultimo_usuario_fk: null,      // ADMINISTRADO DESDE API
	// ultima_actualizacion: null
};
export default {
	name: "RecetaNutricionales",
	props: {
		unidadmedicion: { type: Array, required: true },
		elementonutricional: { type: Array, required: true },
		value: { type: [Array] }
	},
	computed: {
		selectedElementUM(){
			if(!this.form.id_elemento_fk){
				return '';
			}
			let found = _.find(this.elementonutricional, {id_pk: this.form.id_elemento_fk})
			return found.unidaddemediciontextual
		},
		items() {
			let returningData = [];
			_.forEach(this.value, (item) => {
				// item.unidadmedicion = (_.find(this.unidadmedicion, { id_pk: item.id_unidadmedicion_fk }))['nombre'];
				item.elementonutricional = (_.find(this.elementonutricional, { id_pk: item.id_elemento_fk }))['nombre'];
				item.unidaddemediciontextual = (_.find(this.elementonutricional, { id_pk: item.id_elemento_fk }))['unidaddemediciontextual'];
				returningData.push(item);
			});
			return _.sortBy(returningData, 'elementonutricional');
		},
        elementonutricionalDisponible(){
            return _.filter(this.elementonutricional, item => {
                return (_.findIndex(this.value, {id_elemento_fk: item.id_pk}) == -1)
            })
        }
	},
	data: () => {
		return {
			fields: [
                {key: 'elementonutricional', label: 'Elemento', 'sortable': true},
                {key: 'cantidad', 'sortable': true},
                {key: 'unidaddemediciontextual', label: 'Medición del elemento', 'sortable': true},
                {key: '_' }
            ],
			form: _.clone(formArchetype),
		};
	},
	methods: {
		addItem() {
			let cpFullValue = this.value,
                addingItem = _.clone(this.form)
            
            // ADDING ITEM
            addingItem.cantidad = (parseFloat(addingItem.cantidad)).toFixed(4)

            // DATA PUSH
			cpFullValue.push( addingItem );

            // EMIT
			this.$emit("input", cpFullValue);

            // CLEANING
			this.form = _.clone(formArchetype);
		},
        removeItem(item) {
            let cpFullValue = _.clone(this.value)
            cpFullValue.splice(_.findIndex(cpFullValue, {id_elemento_fk: item.id_elemento_fk}), 1)
			this.$emit("input", cpFullValue);
        }
	}
};
</script>

<style lang="less">
#RecetaNutricionales {
}
</style>